import client from './main-client';

export const specDocsApi = (params) => client().get('/specDocs', { params });

export const addSpecDocsApi = (data) => client().post('/specDocs', data);

export const updateSpecDocsApi = (data) => client().put(`/specDocs/${data._id}`, data);

export const removeSpecDocsApi = (data) => client().delete(`/specDocs/${data._id}`);
